import { MessageMedium } from 'constants/messageMediums';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { BaseSendEditorProps } from '../../BaseSendEditor.types';
import { SelectiveInApp } from './SelectiveInApp';
import { SelectivePush } from './SelectivePush';
import { SelectiveTargetingItem } from './SelectiveTargetingItem';

const SelectiveWrapper = styled.div`
  margin-bottom: ${spacing.double};
`;

interface SelectiveTargetingProps extends BaseSendEditorProps {
  onChange?: (mobileAppIds: number[]) => void;
}

export const SelectiveTargeting = (props: SelectiveTargetingProps) => {
  const { shouldShowSelectiveInApp = false, shouldShowSelectivePush = false } = props;

  return (
    <SelectiveWrapper data-test={`selective-targeting-${props.messageMedium}`}>
      <SelectiveTargetingItem
        {...props}
        isShown={shouldShowSelectivePush}
        expectedMessageMedium={MessageMedium.Push}
        SelectComponent={SelectivePush}
      />
      <SelectiveTargetingItem
        {...props}
        isShown={shouldShowSelectiveInApp}
        expectedMessageMedium={MessageMedium.InApp}
        SelectComponent={SelectiveInApp}
      />
    </SelectiveWrapper>
  );
};

export default SelectiveTargeting;
